"use strict";
/* tslint:disable */
var TMultiOptions = (function () {
    "use strict";
    var api = {};
    // tcombo.js - buildComboOptions
    api.buildCombo = function (mode, selections) {
        if (BetSlipUtil.notBuildComboOptions(mode, selections)) {
            return "";
        }
        return BetSlipTemplateConroller.getMultiOptionsTemplate(BetSlip.TemplateType).buildCombo(mode, selections);
    };
    api.buildUKMultiplesOptions = function (mode, selections) {
        if (BetSlipUtil.notBuildUKMultiplesOptions(selections)) {
            return "";
        }
        return BetSlipTemplateConroller.getMultiOptionsTemplate(BetSlip.TemplateType).buildUKMultiplesOptions(mode, selections);
    };
    // tsystem.js - buildComboVariants
    api.buildSystem = function (mode, selections) {
        return BetSlipTemplateConroller.getMultiOptionsTemplate(BetSlip.TemplateType).buildSystem(mode, selections);
    };
    // tteaser.js - buildTeaserOptions
    api.buildTeaser = function (mode, selections) {
        return BetSlipTemplateConroller.getMultiOptionsTemplate(BetSlip.TemplateType).buildTeaser(mode, selections);
    };
    api.buildSystemInnerLayout = function (mode, selections) {
        return BetSlipTemplateConroller.getMultiOptionsTemplate(BetSlip.TemplateType).buildSystemInnerLayout(mode, selections);
    };
    api.buildSystemOptionGroups = function (mode, selections) {
        return BetSlipTemplateConroller.getMultiOptionsTemplate(BetSlip.TemplateType).buildSystemOptionGroups(mode, selections);
    };
    return api;
}());
window.TMultiOptions = TMultiOptions;
jsRequire("/templates/Mobile/UniSlip/TMultiOptions.ext.js");
//# sourceMappingURL=TMultiOptions.js.map